import { useCustomTranslation } from '../../../../../hooks';
import { IconButton } from '@nexelem/components';
import { ProLightEllipsisVertical } from '@nexelem/icons/ProLightEllipsisVertical';
import { useState, type MouseEvent } from 'react';
import { Menu, MenuItem } from '@nexelem/deprecated-theme';
import { useGraphneResourcesSoftUnassignMutation } from '../../../../../queryHooks/productionPlanHooks';
import { useProductionTaskLocate } from '../../Gantt/hooks';
import type { BatchShortViewBase, ResourceDetailsView, TaskShortViewBase } from '@nexelem/graphne-api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleLocationArrow, faUserSlash } from '@fortawesome/pro-light-svg-icons';

export type TaskActionsProps = {
  task: TaskShortViewBase | BatchShortViewBase;
  workerData: ResourceDetailsView;
};

export const TaskActions = ({ workerData, task }: TaskActionsProps) => {
  const isBatch = !('id' in task);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { mutate } = useGraphneResourcesSoftUnassignMutation(isBatch);
  const { tWrapper } = useCustomTranslation('products.productionPlan');
  const locateTask = useProductionTaskLocate();

  const { queue, start } = task;
  const id = isBatch ? task.batchId : task.id;
  const name = isBatch ? task.name : task.productDetails.name;

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUnassign = () => {
    mutate({
      workersData: [workerData],
      task: {
        id,
        name,
      },
    });
    handleClose();
  };

  const locate = () =>
    locateTask({
      taskId: id,
      queueId: queue?.id || 0,
      taskStartDate: start ? new Date(start) : undefined,
    });

  return (
    <>
      <IconButton className="ml-auto" Icon={ProLightEllipsisVertical} onClick={handleOpen} />
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem className="text-t16-sb text-text-action hover:bg-surface-hover-lighter!" onClick={handleUnassign}>
          <FontAwesomeIcon className="mr-2 h-6 w-6" icon={faUserSlash} />
          {tWrapper('taskDetailsDrawer.removeAssignment')}
        </MenuItem>
        <MenuItem className="text-t16-sb text-text-action hover:bg-surface-hover-lighter!" onClick={locate}>
          <FontAwesomeIcon className="mr-2 h-6 w-6" icon={faCircleLocationArrow} />
          {tWrapper('taskDetailsDrawer.locate')}
        </MenuItem>
      </Menu>
    </>
  );
};
